export default __webpack_public_path__ + "static/media/logo_msv_horizontal.45f4e755.png";